import { CarouselTheme } from '../../types';

export const CAROUSEL_DEFAULT_THEME: CarouselTheme = {
    colors: {
        primary: {
            dotsBackground: 'accent.base',
            dotsButtons: 'common.white',
        },
        secondary: {
            dotsBackground: 'primary.base',
            dotsButtons: 'common.white',
        },
        tertiary: {
            dotsBackground: 'secondary.base',
            dotsButtons: 'common.white',
        },
    },
    fixedColors: {
        white: {
            dotsBackground: 'common.white',
            dotsButtons: 'text.body',
        },
    },
};
